import * as React from 'react'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import GenericPage from '../../sections/generic-page'
import Button from '../../components/button'
import Seo from '../../components/seo'

const Cookies = () => {
  return (
    <>
      <Seo
        description="Information om cookies"
        image="https://www.dooer.com/images/og/og_index.jpg"
        title="Information om cookies | Dooer"
        url="https://www.dooer.com/cookies"
      />

      <GenericPage
        buttonText={<FormattedMessage defaultMessage="Ok! Jag har läst klart." id="cookies.button" />}
        ledeText={
          <FormattedMessage
            defaultMessage="Vi använder cookies för att du ska få en så bra upplevelse som möjligt. Vill&nbsp;du&nbsp;ändra&nbsp;dina inställningar så gör du det längst ned på sidan."
            id="cookies.lede"
          />
        }
        titleText={
          <FormattedMessage defaultMessage="Med cookies får du den&nbsp;bästa upplevelsen." id="cookies.title" />
        }
      >
        <FormattedHTMLMessage
          defaultMessage={`
            <h1>Cookie policy</h1>
            <h2>Cookies</h2>
            <p>För att få den här webbplatsen att fungera ordentligt skickar vi ibland små filer till din dator. Dessa filer kallas ”kakor” eller ”cookies”. De flesta större webbplatser gör på samma sätt.</p>
            <h2>Vad är cookies?</h2>
            <p>Cookies är små textfiler som sparas på din dator, telefon eller surfplatta när du besöker webbplatsen. Dessa cookies hjälper webbplatsen att komma ihåg dina inställningar (t.ex. användarnamn, språk, textstorlek och andra förhandsval) under en viss tid. Tanken är att du inte ska behöva göra om inställningarna varje gång du går in på webbplatsen eller bläddrar mellan olika sidor.</p>
            <h2>Hur används cookies?</h2>
            <p>För att ge dig som Dooer-användare en så bra upplevelse som möjligt använder vi cookies på denna webbplats, och liknande tekniker i våra appar. På dooer.com och våra underliggande sidor har vi tredjeparts-cookies, bland annat använder vi Google Analytics för att analysera vår besökstrafik och kunna förbättra vår hemsida kontinuerligt.</p>
            <p>Syftet med användandet av cookies är för att förbättra tjänsterna vi erbjuder. Vi använder cookies för att hantera inloggningar och öka säkerheten för våra kunder, analysera våra användares beteendenanonymt för att veta vilka delar av vår tjänst vi kan förbättra, samt för att komma ihåg inställningar och andra val som du gör på våra webbplatser.</p>
            <p>Vi använder oss även av sessionsbaserade cookies som försvinner så fort du stänger ner din webbläsare, men även mer långlivade cookies för vissa syften.</p>
            <h2>Hantera cookies</h2>
            <p>Du kan kontrollera och radera kakor precis som du vill. Läs mer på aboutcookies.org. Du kan ta bort alla kakor som finns på din dator och du kan ställa in webbläsaren så att den inte tar emot några kakor. I så fall måste du eventuellt göra om vissa inställningar varje gång du går in på en webbplats och vissa tjänster och funktioner kanske inte fungerar.</p>
            <p>Om du vill kan du i webbläsarens inställningar välja att stänga av spårning, vilket innebär att Dooer inte samkör data från våra egna och i förekommande fall våra partners webbplatser.</p>
            <p>För att göra samma sak på din iOS-telefon eller läsplatta kan du begränsa spårning under integritets- och reklaminställningar för webbläsaren, till exempel Safari. På Android gör du detta under Google-inställningar och annonser.</p>
          `}
          id="cookies.policy"
        />
        <Button
          onClick={() => {
            window.document.cookie = 'CookieConsent=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT'
            window.location.reload()
          }}
        >
          <FormattedMessage defaultMessage="Jag vill ändra mitt val" id="cookies.button-change" />
        </Button>
      </GenericPage>
    </>
  )
}

export default Cookies
